"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicShouldFetchChecker = basicShouldFetchChecker;

var _underscore = require("underscore");

var MAX_DATA_AGE = 300000; // 5 minutes in millis

function basicShouldFetchChecker(state, branch) {
  var relevantBranch = state[branch]; // TODO currently we are only interested in this if this branch has never been fetched before. Update to check against the timestamp.

  if (relevantBranch.isFetching) {
    // if we are currently fetching, no need to fetch again
    return false;
  } else if ((0, _underscore.isUndefined)(relevantBranch.lastFetched)) {
    // if we don't have a defined timestamp, we have never fetched before. Fetch!
    return true;
  } else if (relevantBranch.lastFetched - Date.now() > MAX_DATA_AGE) {
    // data is out-dated. Let's get some new stuff.
    return true;
  } else if (branch === 'dynos' && relevantBranch.hasMore) {
    // i.e. we deed the initial load of dynos, but we still need to get the rest.
    return true;
  } else if (relevantBranch.table && !relevantBranch.table.searched) {
    // when the search term has changed
    return true;
  } // default to not fetching. The only times we want to fetch are handled above.


  return false;
}